exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "profile-page .profilNav .profil{text-decoration:none;padding:.4em 0;display:inline-block}profile-page .profilNav .profil.active{font-weight:700}profile-page a.button.cancel{background:#000;color:#fff}profile-page a.button.cancel:after{content:\"\\E60E\"}profile-page a.button.cancel:hover{background-color:#666}profile-page section.primary.card{padding-bottom:0!important}profile-page .userName{overflow:hidden;text-overflow:ellipsis}@media (min-width:600px){profile-page section.primary.card{min-height:602px}}@media (max-width:599px){profile-page section.primary.card{min-height:450px}}@media (max-width:400px){profile-page section.primary.card{min-height:400px}}profile-page .txtUppercase{overflow:hidden;text-overflow:ellipsis}@media (max-width:420px){profile-page .txtUppercase{width:160px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/profile/profile.styl
// module id = 1005
// module chunks = 0